import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from './filter-nav';

export function DenyRoles({ roles, children }: { roles: string[]; children: ReactNode }) {
  const { role } = getCurrentUser();
  if (role && roles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

/** Inverse of DenyRoles — only the listed roles may reach the route. */
export function AllowRoles({ roles, children }: { roles: string[]; children: ReactNode }) {
  const { role } = getCurrentUser();
  if (!role || !roles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

export function RequireModuleAcl({
  module,
  operation,
  allowRoles,
  denyRoles,
  allowIfOwnCompany,
  children,
}: {
  module: string;
  operation: 'read' | 'add' | 'edit' | 'delete';
  allowRoles?: string[];
  denyRoles?: string[];
  allowIfOwnCompany?: boolean;
  children: ReactNode;
}) {
  const { role, moduleOperations, isOwnCompany } = getCurrentUser();
  const roleAllowed =
    !allowRoles ||
    (!!role && allowRoles.includes(role)) ||
    (allowIfOwnCompany === true && isOwnCompany);
  const allowed =
    !!moduleOperations?.[module]?.[operation] &&
    roleAllowed &&
    (!denyRoles || !role || !denyRoles.includes(role));

  if (!allowed) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
